import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * Custom navigation hook that preserves iframe-related URL parameters
 * This ensures hideNav and other iframe params persist across navigation
 */
export function useIframeNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithParams = useCallback((to: string) => {
    // Parse current URL parameters
    const currentParams = new URLSearchParams(location.search);
    
    // Preserve iframe-related parameters
    const preservedParams = new URLSearchParams();
    
    // List of parameters to preserve
    const paramsToPreserve = ['hideNav', 'hidenav', 'tenant', 'user'];
    
    paramsToPreserve.forEach(param => {
      const value = currentParams.get(param);
      if (value !== null) {
        preservedParams.set(param, value);
      }
    });
    
    // Construct the new URL with preserved params
    const separator = to.includes('?') ? '&' : '?';
    const paramsString = preservedParams.toString();
    const newPath = paramsString ? `${to}${separator}${paramsString}` : to;
    
    navigate(newPath);
  }, [navigate, location.search]);

  return navigateWithParams;
}